import { render, staticRenderFns } from "./view_picture.vue?vue&type=template&id=3c62abf1&scoped=true&"
import script from "./view_picture.vue?vue&type=script&lang=js&"
export * from "./view_picture.vue?vue&type=script&lang=js&"
import style0 from "./view_picture.vue?vue&type=style&index=0&id=3c62abf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62abf1",
  null
  
)

export default component.exports